import { trace } from "./utils";

class DefaultListener {

    onCall() {
        trace("DefaultListener: onCall");
    }

    onIncomingCall(callId:any):void {
        trace("DefaultListener: onIncomingCall");
        if (callId) console.log();
        
    }

    onAnswer(callId:any):void {
        trace("DefaultListener: onAnswer");
        if (callId) console.log();
    }

    onError() {
        trace("DefaultListener: onError");
    }

    onHangup() {
        trace("DefaultListener: onHangup");
    }

    onRegistered() {
        trace("DefaultListener: onRegistered");
    }

    onRemoveCall() {
        trace("DefaultListener: onRemoveCall");
    }
};

export default DefaultListener